import type { AllRouteEndpoints } from "../routeTypes";
export const appsUserInfoUpdateMergeDuplicateUsersRulesCacheKeys: AllRouteEndpoints[] = [
  "/apps/user_info/merge_duplicate_users_rules",
];
